export let HubsTrackingAttr;

(function (HubsTrackingAttr) {
  HubsTrackingAttr["Id"] = "hubs_id";
  HubsTrackingAttr["Content"] = "hubs_content";
  HubsTrackingAttr["Medium"] = "hubs_medium";
  HubsTrackingAttr["Source"] = "hubs_source";
  HubsTrackingAttr["Campaign"] = "hubs_campaign";
  HubsTrackingAttr["Cta"] = "hubs_cta";
})(HubsTrackingAttr || (HubsTrackingAttr = {}));